import { createAsyncThunk } from '@reduxjs/toolkit';
export const LoadUserSummaryFromStorage = createAsyncThunk(
    'userSummary/loadUserSummaryFromStorage',
    async () => {
        return localStorage.getItem('loggedInUserSummary');
    }
);
